import { render } from "./NicuManagement.vue?vue&type=template&id=1055e115&scoped=true"
import script from "./NicuManagement.vue?vue&type=script&lang=js"
export * from "./NicuManagement.vue?vue&type=script&lang=js"

import "./NicuManagement.vue?vue&type=style&index=0&id=1055e115&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1055e115"]])

export default __exports__